/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_Tap_CancelInputs */

const en_follow_tap_cancel = /** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tap to cancel`)
};

const es_follow_tap_cancel = /** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`toca para cancelar`)
};

const fr_follow_tap_cancel = /** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`appuyez pour annuler`)
};

const de_follow_tap_cancel = /** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Abbrechen tippen`)
};

const id_follow_tap_cancel = /** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ketuk untuk batal`)
};

/** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */
const ja_follow_tap_cancel = en_follow_tap_cancel;

/** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */
const zh_follow_tap_cancel = en_follow_tap_cancel;

/** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */
const ar_follow_tap_cancel = en_follow_tap_cancel;

/** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */
const it_follow_tap_cancel = en_follow_tap_cancel;

/** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */
const ru_follow_tap_cancel = en_follow_tap_cancel;

/** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */
const pt_follow_tap_cancel = en_follow_tap_cancel;

/** @type {(inputs: Follow_Tap_CancelInputs) => LocalizedString} */
const ko_follow_tap_cancel = en_follow_tap_cancel;

/**
* | output |
* | --- |
* | "tap to cancel" |
*
* @param {Follow_Tap_CancelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_tap_cancel = /** @type {((inputs?: Follow_Tap_CancelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_Tap_CancelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_tap_cancel(inputs)
	if (locale === "es") return es_follow_tap_cancel(inputs)
	if (locale === "fr") return fr_follow_tap_cancel(inputs)
	if (locale === "de") return de_follow_tap_cancel(inputs)
	if (locale === "ja") return ja_follow_tap_cancel(inputs)
	if (locale === "zh") return zh_follow_tap_cancel(inputs)
	if (locale === "ar") return ar_follow_tap_cancel(inputs)
	if (locale === "id") return id_follow_tap_cancel(inputs)
	if (locale === "it") return it_follow_tap_cancel(inputs)
	if (locale === "ru") return ru_follow_tap_cancel(inputs)
	if (locale === "pt") return pt_follow_tap_cancel(inputs)
	return ko_follow_tap_cancel(inputs)
});